import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/arrow-right.svg'
import _imports_1 from '@/assets/gesture-hand.svg'


const _withScopeId = n => (_pushScopeId("data-v-12caeefa"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "card card-invis"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gesture" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "gesturehandleft",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "gesturehandright",
    src: _imports_0
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckMark = _resolveComponent("CheckMark")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", _ctx.markClass]),
      style: _normalizeStyle({ zIndex: _ctx.zIndex })
    }, null, 6),
    _createElementVNode("div", {
      class: _normalizeClass(["card card-mark", _ctx.markClass]),
      style: _normalizeStyle(_ctx.markStyle)
    }, [
      _createVNode(_component_CheckMark, {
        class: "mark",
        "is-tick": _ctx.isLeaningRight
      }, null, 8, ["is-tick"])
    ], 6),
    _createElementVNode("div", {
      ref: "info",
      class: _normalizeClass(["card card-info", _ctx.infoClass]),
      style: _normalizeStyle(_ctx.infoStyle)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["index", { exampleOpacity: _ctx.exampleSwipe }])
      }, _toDisplayString(_ctx.indexText), 3),
      _createElementVNode("div", {
        class: _normalizeClass(["question", { exampleOpacity: _ctx.exampleSwipe }]),
        innerHTML: _ctx.question.question
      }, null, 10, _hoisted_1),
      _createElementVNode("img", {
        class: _normalizeClass(["image", { exampleOpacity: _ctx.exampleSwipe }]),
        draggable: "false",
        src: _ctx.question.image
      }, null, 10, _hoisted_2)
    ], 6),
    (_ctx.exampleSwipe)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true)
  ], 64))
}